export const SET_MOBILE = 'SET_MOBILE';
export const SET_ACTIVE_GUIDE_PAGE = 'SET_ACTIVE_GUIDE_PAGE';
